
import { MoreVertical, Pin, Edit, Trash2, Share2, Bookmark, Flag } from "lucide-react"
import { useState, useRef, useEffect } from "react"

export function MessageMenu({ messageId, onEdit, onDelete, onPin, isPinned }) {
  const [isOpen, setIsOpen] = useState(false)
  const menuRef = useRef(null)

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [])

  const menuItems = [
    { icon: Edit, label: "Edit Message", onClick: onEdit },
    { icon: Pin, label: isPinned ? "Unpin Message" : "Pin Message", onClick: onPin },
    { icon: Share2, label: "Share Message", onClick: () => {} },
    { icon: Bookmark, label: "Save Message", onClick: () => {} },
    { icon: Flag, label: "Report Message", onClick: () => {} },
    { icon: Trash2, label: "Delete Message", onClick: onDelete, danger: true },
  ]

  return (
    <div className="relative" ref={menuRef}>
      <button onClick={() => setIsOpen(!isOpen)} className="p-1 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800">
        <MoreVertical className="w-4 h-4 text-gray-400" />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-56 rounded-xl bg-white dark:bg-gray-900 shadow-lg border border-gray-200 dark:border-gray-800 py-1 z-50">
          {menuItems.map((item, index) => (
            <button
              key={index}
              onClick={() => {
                item.onClick?.()
                setIsOpen(false)
              }}
              className={`w-full flex items-center gap-2 px-4 py-2 text-sm ${
                item.danger
                  ? "text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20"
                  : "text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800"
              }`}
            >
              <item.icon className="w-4 h-4" />
              {item.label}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}

